/* eslint-disable react/prop-types */

import React, {useState} from "react";
import type ConstructionNewDeleteTagsDialogProps from "./ConstructionNewDeleteTagsDialogProps";
import type ApiResponse from "../../../../services/api/types/ApiResponse";
import type TagDto from "../../../../dto/construction/TagDto";
import IsaacDialog from "../../../../components/isaacDialog/IsaacDialog";
import styles from "./ConstructionNewDeleteTagsDialog.module.scss";
import {DefaultButton, DialogFooter, DialogType, PrimaryButton} from "@fluentui/react";
import useConstructionNewTagHook from "./hooks/useConstructionNewTagHook";
import {removeTag} from "../../constructionNewSlice";
import {removeTagFromConstruction} from "../../../constructionsNew/constructionsNewSlice";
import {useDispatch} from "react-redux";

const ConstructionNewDeleteTagsDialog: React.FunctionComponent<ConstructionNewDeleteTagsDialogProps> = ({
  isHidden,
  handleDismiss,
  tag,
  constructionId,
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [result, setResult] = useState<ApiResponse<TagDto[]> | undefined>();
  const {deleteTagFromConstruction} = useConstructionNewTagHook();
  const dispatch = useDispatch();

  const handleTagDeletion = async (): Promise<void> => {
    setIsLoading(true);
    if (tag !== undefined && constructionId !== undefined) {
      const response = await deleteTagFromConstruction(constructionId, [{value: tag}]);

      await new Promise(resolve => setTimeout(resolve, 2000));

      setResult(response);
      if (response.success) {
        dispatch(removeTag(tag));
        dispatch(removeTagFromConstruction({tag, constructionId}));
        handleDismiss();
      }
    }
    setIsLoading(false);
  };
  return (
    <IsaacDialog
      isLoading={isLoading}
      isHidden={isHidden}
      successMessage="Tag was successfully removed."
      errorMessage="Tag was not removed."
      error={result?.errors}
      modalProps={{
        titleAriaId: "NewCalculation",
        subtitleAriaId: "mySubTextId",
        isBlocking: true,
        containerClassName: `ms-dialogMainOverride ${styles.deleteDialog}`,
      }}
      dialogContentProps={{
        type: DialogType.normal,
        title: "Remove tag from construction",
        subText: "Are you sure you want to remove tag from construction?",
      }}
      handleDialogDismiss={handleDismiss}>
      <DialogFooter>
        {/* eslint-disable-next-line no-void */}
        <PrimaryButton onClick={() => void handleTagDeletion()} text="Confirm" />
        <DefaultButton onClick={handleDismiss} text="Cancel" />
      </DialogFooter>
    </IsaacDialog>
  );
};
export default ConstructionNewDeleteTagsDialog;
